import { useEffect, useRef, useState } from "react";
import { motion, useAnimation, useInView } from "framer-motion";
import { CgTwilio } from "react-icons/cg";
import { FaCode, FaGlobe, FaPlay } from "react-icons/fa";
import { CiMobile3 } from "react-icons/ci";
import { FaMobileScreenButton } from "react-icons/fa6";
import { RiMobileDownloadFill } from "react-icons/ri";
import { Link } from "react-router-dom";
import { FaArrowRight, FaSearchPlus, FaTimes } from "react-icons/fa";
import { CTABanner, StatsRow } from "../../Components/PortfolioBlocks";
import BrandButton from "../../Components/BrandButton";

const ctaAccent = { base: "#059669", hover: "#047857", dark: "#065F46", soft: "#ECFDF5", rgb: "6, 95, 70" };
export const A2PApproval = () => {

    const audioRef = useRef(null);
    const progressBarRef = useRef(null);

    const [isPlaying, setIsPlaying] = useState(false);
    const [isEnded, setIsEnded] = useState(false);



    const fadeUp = {
        hidden: { opacity: 0, y: 30 },
        show: (i = 0) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: i * 0.15,
                duration: 0.6,
                ease: "easeOut",
            },
        }),
    };

    const fadeUp2 = {
        hidden: { opacity: 0, y: 30 },
        visible: (delay = 0) => ({
            opacity: 1,
            y: 0,
            transition: { duration: 0.8, ease: "easeOut", delay },
        }),
    };

    const headingRef = useRef(null);
    const paragraphRef = useRef(null);

    const headingControls = useAnimation();
    const paragraphControls = useAnimation();

    const isHeadingInView = useInView(headingRef, { once: true, amount: 0.4 });
    const isParagraphInView = useInView(paragraphRef, {
        once: true,
        amount: 0.4,
    });

    useEffect(() => {
        if (isHeadingInView) {
            headingControls.start("visible");
        }
    }, [isHeadingInView]);

    useEffect(() => {
        if (isParagraphInView) {
            paragraphControls.start("visible");
        }
    }, [isParagraphInView]);

    const imageFrames = [
        "/a2p2.png",
        "/a2p3.png",
        "/a2p4.png",
        "/a2p5.png",
        "/a2p6.png",
        "/a2p7.png",
        "/a2p8.png",
        "/a2p9.png",
        "/a2p10.png",

    ];

    const a2pPlatforms = [
        { name: "Twilio", approvalChance: "100%" },
        { name: "GoHighLevel (GHL)", approvalChance: "100%" },
        { name: "Telnyx", approvalChance: "98%" },
        { name: "Grasshopper", approvalChance: "97%" },
        { name: "RingCentral", approvalChance: "96%" },
        { name: "Microsoft", approvalChance: "95%" },
        { name: "Vonage", approvalChance: "94%" },
        { name: "Quo", approvalChance: "93%" },
    ];

    const [index, setIndex] = useState(0);
    const platformRef = useRef(null);
    const width = 1050;

    const next = () => {
        if (index < imageFrames.length - 1) setIndex(index + 1);
    };

    const prev = () => {
        if (index > 0) setIndex(index - 1);
    };

    const goTo = (target) => {
        if (target === "end") setIndex(imageFrames.length - 1);
        else if (!isNaN(target)) setIndex(Number(target));
    };

    useEffect(() => {
        const handleKey = (e) => {
            if (e.key === "ArrowRight") next();
            if (e.key === "ArrowLeft") prev();
        };
        window.addEventListener("keydown", handleKey);
        return () => window.removeEventListener("keydown", handleKey);
    }, [index]);



    const [callState, setCallState] = useState("incoming");

    const [active, setActive] = useState(null);

useEffect(() => {
    if (!active) return undefined;
    const onKey = (e) => e.key === "Escape" && setActive(null);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
        window.removeEventListener("keydown", onKey);
        document.body.style.overflow = prevOverflow;
    };
}, [active]);

const stats = [
    { value: "", label: "A2P campaigns approved" },
    { value: "", label: "Average approval time" },
    { value: "", label: "Messaging platforms supported" },
];

//    const stats = [
//     { value: "A2P 10DLC", label: "Brand & campaign registration" },
//     { value: "8", label: "Messaging platforms supported" },
//     { value: "SMS + MMS", label: "Compliant messaging setups" },
// ];

    return (
        <section className="text-black">
            <div className="mt-20 font-sans overflow-x-hidden relative ">
                <section className="relative z-10 py-16 md:py-24 px-6 md:px-12 lg:px-24">
                    <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center text-center lg:text-left">
                        <div className="space-y-8">
                            <motion.div
                                variants={fadeUp}
                                initial="hidden"
                                animate="show"
                                custom={0}
                            >
                                <div className="inline-flex justify-center items-center px-4 py-2 rounded-full bg-[#34d39931] text-center text-primary-dark font-medium mx-auto lg:mx-0">
                                    <span className="relative flex h-3 w-3 mr-2">
                                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#34D399] opacity-75"></span>
                                        <span className="relative inline-flex rounded-full h-3 w-3 bg-primary-dark"></span>
                                    </span>
                                    <span className="text-[#34D399]">A2P Approval</span>
                                </div>
                            </motion.div>
                            <motion.h1
                                className="text-4xl sm:text-4xl md:text-5xl lg:text-6xl font-display font-bold tracking-tight text-gray-900 text-center lg:text-left"
                                initial={{ y: 20 }}
                                animate={{ y: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut" }}
                            >
                               Multi-Platform Messaging Solutions{" "}
                                <span className="text-[#34D399]">
                                    with Guaranteed A2P Approval
                                </span>
                            </motion.h1>

                            <motion.p
                                className="text-md md:text-xl text-gray-600 max-w-2xl mt-2 text-center lg:text-left md:text-center"
                                initial={{ y: 20 }}
                                animate={{ y: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.1 }}
                            >
                                We handle the complete A2P 10DLC registration process across
                                Twilio, GHL, and other messaging platforms for
                                you - from brand verification to campaign submission - ensuring
                                100% approval and compliance.
                                <span className="ml-2 font-semibold">
                                    Send SMS and MMS with confidence, stay compliant, and reach
                                    customers without message filtering or delays.
                                </span>
                            </motion.p>

                            <motion.div
                                variants={fadeUp}
                                initial="hidden"
                                animate="show"
                                custom={3}
                                className="flex flex-wrap gap-4 justify-center lg:justify-start"
                            >
                                <BrandButton as={Link} to="/contact" accent={ctaAccent}>
                                    Start Your A2P Registration
                                </BrandButton>
                            </motion.div>

                            <motion.p
                                className="text-sm md:text-md text-gray-600 max-w-2xl"
                                variants={fadeUp}
                                initial="hidden"
                                animate="show"
                                custom={4}
                            >
                                Experience hassle-free messaging - faster approvals, higher
                                deliverability, and fully compliant multi-platform setups.
                            </motion.p>
                        </div>

                        <div className="relative">
                           <motion.div
                                initial={{ y: 30 }}
                                animate={{ y: 0 }}
                                transition={{ duration: 0.6, ease: "easeOut" }}
                                className="relative w-full max-w-md mx-auto rounded-3xl shadow-2xl bg-[#34d39934] border border-gray-100 p-6"
                            >
                                <div className="bg-white/80 backdrop-blur-sm border border-gray-100 rounded-2xl  text-center relative">
                                    <motion.div
                                        variants={fadeUp}
                                        initial="hidden"
                                        animate="show"
                                        custom={4}
                                        className="absolute -top-10 p-8 text-5xl -right-20 text-[#34D399] rounded-2xl bg-[#34d39934] backdrop-blur-sm shadow-lg z-20"
                                    >
                                        <CgTwilio />
                                    </motion.div>

                                    <motion.div
                                        variants={fadeUp}
                                        initial="hidden"
                                        animate="show"
                                        custom={6}
                                        className="absolute top-64 p-4 text-5xl -left-14 text-[#34D399] rounded-2xl bg-[#34d39934] backdrop-blur-sm shadow-lg z-20"
                                    >
                                        <CgTwilio />
                                    </motion.div>
                                    <div className="p-6 bg-white rounded-lg shadow-lg max-w-md mx-auto">
                                        {/* Header */}
                                        <div className="text-sm font-medium text-gray-500 mb-2">
                                            Campaign Status
                                        </div>
                                        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                                            A2P 10DLC Campaign
                                        </h2>

                                        {/* Message preview */}
                                        <div className="bg-[#F9FAFB] border border-gray-200 rounded-lg p-4 mb-4">
                                            <p className="text-gray-800 text-sm">
                                                📢 *Exclusive Deal!* - 25% off for our subscribers this
                                                week only. Reply{" "}
                                                <span className="font-semibold">YES</span> to claim or{" "}
                                                <span className="font-semibold">STOP</span> to opt out.
                                            </p>
                                        </div>

                                        {/* Delivery progress */}
                                        <div className="space-y-2 mb-6">
                                            <div className="flex justify-between text-sm">
                                                <span className="text-gray-600">Contacts Reached</span>
                                                <span className="font-medium text-gray-900">
                                                    940 / 1,000
                                                </span>
                                            </div>
                                            <div className="w-full bg-gray-200 rounded-full h-2">
                                                <div
                                                    className="bg-[#34D399] h-2 rounded-full"
                                                    style={{ width: "94%" }}
                                                ></div>
                                            </div>
                                            <div className="flex justify-between text-sm">
                                                <span className="text-gray-600">Delivery Rate</span>
                                                <span className="font-medium text-gray-900">99%</span>
                                            </div>
                                        </div>

                                        {/* Status badges */}
                                        <div className="flex flex-wrap gap-2 mb-6">
                                            <span className="px-3 py-1 bg-green-100 text-[#34D399] text-xs font-semibold rounded-full">
                                                Approved
                                            </span>
                                            <span className="px-3 py-1 bg-blue-100 text-blue-800 text-xs font-semibold rounded-full">
                                                Compliant
                                            </span>
                                            <span className="px-3 py-1 bg-yellow-100 text-yellow-800 text-xs font-semibold rounded-full">
                                                In Progress
                                            </span>
                                        </div>

                                        {/* Controls */}
                                        <div className="flex justify-center space-x-6">
                                            <button className="px-4 py-2 bg-[#34D399] text-white rounded-lg shadow  text-sm font-medium">
                                                Stop Campaign
                                            </button>
                                            <button className="px-4 py-2 bg-[#34D399] text-white rounded-lg shadow text-sm font-medium">
                                                Send Now
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </motion.div>
                        </div>
                    </div>
                </section>
            </div>

            <StatsRow items={stats} color="#059669" />

            <section className="px-6 md:px-12 lg:px-24 pb-8 mt-10 md:pb-14">
                <div className="max-w-7xl mx-auto">
                    <motion.p
                        className="text-center text-sm md:text-base tracking-widest text-slate-600"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3, ease: "easeOut" }}
                        viewport={{ once: true }}
                    >
                        <span className="border-b border-dotted border-slate-300 ml-2">
                            Platforms We Handle                        </span>

                    </motion.p>
                    <motion.h2
                        className="mx-auto mt-4 text-center max-w-4xl font-display text-3xl sm:text-3xl md:text-5xl font-semibold tracking-tight text-slate-900  leading-tight"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3, ease: "easeOut", delay: 0.15 }}
                        viewport={{ once: true }}
                    >
                        A2P Submissions Across Leading Messaging Platforms
                    </motion.h2>
                    <motion.p
                        className=" text-center mx-auto mt-9 max-w-2xl text-lg tracking-tight text-slate-600 sm:mt-6"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3, ease: "easeOut", delay: 0.3 }}
                        viewport={{ once: true }}
                    >
                        We submit and manage compliant A2P registrations across multiple
                        platforms so your campaigns launch faster and stay approved.
                    </motion.p>

                    <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
                        {a2pPlatforms.map((platform, i) => (
                           <motion.div
                                key={platform.name}
                                className="rounded-xl border border-emerald-100 bg-white shadow-sm px-4 py-3 text-center transition-shadow duration-300 hover:border-emerald-300 hover:shadow-lg"
                                initial={{ opacity: 0, y: 18 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                whileHover={{ y: -4 }}
                                transition={{ duration: 0.25, ease: "easeOut", delay: i * 0.05 }}
                                viewport={{ once: true }}
                            >
                                <p className="text-sm md:text-base font-medium text-slate-800">
                                    {platform.name}
                                </p>
                                <p className="mt-1 text-xs md:text-sm text-emerald-700 font-semibold">
                                    Approval Chance: {platform.approvalChance}
                                </p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>
            <div className="flex justify-center items-center">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-10 pb-16 text-center lg:pt-20">
                    <motion.p
                        className="mx-auto -mt-4 max-w-2xl text-md tracking-widest text-slate-700 sm:mt-6"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3, ease: "easeOut" }}
                        viewport={{ once: true }}
                    >
                        Our
                        <span className="border-b border-dotted border-slate-300 ml-2">
                            Multi-Platform Messaging Work
                        </span>
                    </motion.p>

                    <motion.h2
                        className="mx-auto mt-4 max-w-4xl font-display text-3xl sm:text-3xl md:text-5xl font-semibold tracking-tight text-slate-900  leading-tight"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3, ease: "easeOut", delay: 0.3 }}
                        viewport={{ once: true }}
                    >
                        <span className="inline-block">
                            Some of Our A2P-Approved Messaging Solutions
                        </span>
                    </motion.h2>

                    <motion.p
                        className="mx-auto mt-9 max-w-2xl text-lg tracking-tight text-slate-600 sm:mt-6"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3, ease: "easeOut", delay: 0.6 }}
                        viewport={{ once: true }}
                    >
                        Explore a showcase of Twilio, GHL, and multi-platform messaging
                        systems we've delivered - each designed for guaranteed A2P 10DLC
                        approval, maximum deliverability, and seamless compliance. From
                        campaign registration to high-volume SMS workflows, our solutions
                        keep your messages reaching customers without delays or filtering.
                    </motion.p>
                    {/* Carousel - only for md and up */}
                    <motion.div
                        className="gallery w-full rounded mx-auto m-5 hidden md:block"
                        style={{ maxWidth: `${width}px` }}
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3, ease: "easeOut", delay: 0.9 }}
                        viewport={{ once: true }}
                    >
                       <div className="content-area w-full overflow-hidden">
                            <div
                                className="platform flex transition-transform duration-300"
                                style={{
                                    width: `${imageFrames.length * 100}%`,
                                    transform: `translateX(-${(index * 100) / imageFrames.length}%)`,
                                }}
                            >
                                {imageFrames.map((src, i) => (
                                    <div
                                        key={i}
                                        className="each-frame flex-none flex items-center justify-center"
                                        style={{ width: `${100 / imageFrames.length}%` }}
                                    >
                                        <button
                                            type="button"
                                            onClick={() => setActive({ src, caption: `Frame ${i + 1}` })}
                                            aria-label={`Enlarge frame ${i + 1}`}
                                            className="block w-full cursor-zoom-in"
                                        >
                                            <img
                                                src={src}
                                                width="1200"
                                                height="600"
                                                loading="lazy"
                                                decoding="async"
                                                className="w-full h-auto border-2 rounded-2xl object-contain"
                                                alt={`Frame ${i + 1}`}
                                            />
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Carousel buttons */}
                        <div className="top flex p-2 items-center justify-center">
                            <div className="buttons flex gap-3 text-gray-600 mr-1">
                                <motion.svg
                                    whileHover={{ scale: 1.2 }}
                                    whileTap={{ scale: 1.1 }}
                                    onClick={prev}
                                    className="w-10 rounded-lg bg-[#34D399] p-2 cursor-pointer"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="#fff"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M10 19l-7-7m0 0l7-7m-7 7h18"
                                    />
                                </motion.svg>
                                <motion.svg
                                    whileHover={{ scale: 1.2 }}
                                    whileTap={{ scale: 1.1 }}
                                    onClick={next}
                                    className="w-10 rounded-lg bg-[#34D399] p-2 cursor-pointer"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="#fff"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                                    />
                                </motion.svg>
                            </div>
                        </div>
                    </motion.div>

                    {/* Column layout for small screens */}
                    <div className="flex mt-10 flex-col md:hidden">
                        {imageFrames.map((src, i) => (
                            <div
                                key={i}
                                className="w-full flex items-center justify-center mb-4"
                            >
                               <button
                                    type="button"
                                    onClick={() => setActive({ src, caption: `Frame ${i + 1}` })}
                                    className="block w-full"
                                >
                                    <img
                                        src={src}
                                        width="1200"
                                        height="600"
                                        loading="lazy"
                                        decoding="async"
                                        className="w-full h-auto border-2 rounded-2xl object-contain"
                                        alt={`Frame ${i + 1}`}
                                    />
                                </button>
                            </div>
                        ))}
                    </div>
                   </div>
            </div>

            <CTABanner
                title="Need your A2P registration done right?"
                text="Tell us your platform and use case, and we will handle brand verification and campaign submission."
                buttonLabel="Start Your A2P Registration"
                color="#059669"
                hoverBg="#ecfdf5"
            />

            {active && (
                <motion.div
                    className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/80 p-4"
                    onClick={() => setActive(null)}
                    role="dialog"
                    aria-modal="true"
                    aria-label={active.caption}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.2 }}
                >
                    <button
                        type="button"
                        onClick={() => setActive(null)}
                        aria-label="Close"
                        className="absolute right-5 top-5 flex h-10 w-10 items-center justify-center rounded-full bg-white text-slate-900 shadow-lg"
                    >
                        <FaTimes />
                    </button>
                    <motion.img
                        src={active.src}
                        alt={active.caption}
                        onClick={(e) => e.stopPropagation()}
                        initial={{ opacity: 0, scale: 0.97 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.25, ease: "easeOut" }}
                        className="max-h-[90vh] max-w-full rounded-lg object-contain shadow-2xl"
                    />
                </motion.div>
            )}
        </section>
    )
}
